import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';
import Swal from 'sweetalert2';
import PoServices from '../../../services/PoServices';

const stateCityData ={
  "Andhra Pradesh": [
    "Visakhapatnam","Vijayawada","Guntur","Nellore","Tirupati","Kakinada",
    "Rajahmundry","Kadapa","Anantapur","Kurnool","Eluru","Ongole","Chittoor",
    "Vizianagaram","Srikakulam","Machilipatnam","Tenali","Bhimavaram","Adoni",
    "Madanapalle","Nandyal","Proddatur","Hindupur","Tadepalligudem",
    "Gudivada","Dharmavaram","Guntakal","Narasaraopet","Tadipatri","Kavali"
  ],
  "Arunachal Pradesh": [
    "Itanagar","Naharlagun","Pasighat","Aalo","Seppa","Tezu","Daporijo","Namsai",
    "Ziro","Roing","Tawang","Khonsa","Bomdila","Deomali","Changlang","Miao",
    "Basar","Dirang","Anini","Koloriang","Rupa","Boleng","Hawai","Jairampur",
    "Yingkiong","Hayuliang","Longding","Pangin","Likabali","Miao"
  ],
  "Assam": [
    "Guwahati","Silchar","Dibrugarh","Jorhat","Nagaon","Tezpur","Tinsukia",
    "Bongaigaon","Diphu","Dhubri","North Lakhimpur","Karimganj","Sivasagar",
    "Goalpara","Barpeta","Golaghat","Lumding","Haflong","Rangia","Mangaldoi",
    "Lanka","Hojai","Barpeta Road","Kokrajhar","Hailakandi","Dhekiajuli","Dergaon"
  ],
  "Bihar": [
    "Patna","Gaya","Bhagalpur","Muzaffarpur","Purnia","Darbhanga","Bihar Sharif",
    "Arrah","Begusarai","Katihar","Munger","Chhapra","Sasaram","Bettiah",
    "Motihari","Saharsa","Hajipur","Dehri","Siwan","Sitamarhi","Jamalpur",
    "Jehanabad","Aurangabad (Bihar)","Buxar","Kishanganj","Nawada","Bagaha","Danapur"
  ],
  "Chhattisgarh": [
    "Raipur","Bhilai","Durg","Bilaspur","Korba","Rajnandgaon","Raigarh",
    "Jagdalpur","Ambikapur","Chirmiri","Dhamtari","Mahasamund","Bhatapara",
    "Dalli‑Rajhara","Kawardha","Champa","Dongragarh","Tilda Neora","Mungeli",
    "Manendragarh","Kondagaon","Gobranawapara","Bemetara","Baikunthpur"
  ],
  "Goa": [
    "Panaji","Vasco da Gama","Margao","Mapusa","Ponda","Bicholim","Curchorem",
    "Sanquelim","Valpoi","Quepem","Canacona","Sanguem","Cuncolim","Pernem","Mormugao"
  ],
  "Gujarat": [
    "Ahmedabad","Surat","Vadodara","Rajkot","Bhavnagar","Jamnagar","Junagadh",
    "Gandhinagar","Anand","Navsari","Surendranagar","Morbi","Gandhidham",
    "Nadiad","Bharuch","Patan","Porbandar","Mehsana","Bhuj","Veraval","Vapi",
    "Valsad","Godhra","Palanpur","Kalol","Botad","Amreli","Deesa","Dahod",
    "Ankleshwar","Jetpur"
  ],
  "Haryana": [
    "Gurugram","Faridabad","Ambala","Panipat","Yamunanagar","Karnal","Hisar",
    "Panchkula","Rohtak","Rewari","Jind","Sonipat","Narnaul","Kaithal",
    "Pehowa","Kurukshetra","Bahadurgarh"
  ],
  "Himachal Pradesh": [
    "Shimla","Mandi","Solan","Dharamshala","Hamirpur","Bilaspur","Una",
    "Chamba","Palampur","Kangra","Nadaun"
  ],
  "Jharkhand": [
    "Ranchi","Jamshedpur","Dhanbad","Bokaro","Deoghar","Hazaribagh",
    "Giridih","Jharia","Ramgarh","Phusro","Chas","Medininagar"
  ],
  "Karnataka": [
    "Bengaluru","Mysuru","Hubli-Dharwad","Mangaluru","Belagavi","Kalaburagi",
    "Davangere","Ballari","Shivamogga","Tumakuru","Udupi","Vijayapura",
    "Bidar","Raichur","Hassan","Karwar","Chitradurga"
  ],
  "Kerala": [
    "Thiruvananthapuram","Kochi","Kozhikode","Thrissur","Alappuzha","Kollam",
    "Palakkad","Kannur","Kottayam","Malappuram","Pathanamthitta","Thalassery",
    "Ponnani","Wayanad","Attingal","Pala","Perinthalmanna"
  ],
  "Madhya Pradesh": [
    "Indore","Bhopal","Jabalpur","Gwalior","Ujjain","Sagar","Dewas","Satna",
    "Rewa","Ratlam","Chhindwara","Dhar","Morena","Guna","Neemuch","Vidisha",
    "Shivpuri","Sehore","Burhanpur"
  ],
  "Maharashtra": [
    "Mumbai","Pune","Nagpur","Thane","Nashik","Kalyan-Dombivli","Vasai-Virar",
    "Aurangabad","Solapur","Amravati","Navi Mumbai","Kolhapur","Ulhasnagar",
    "Nanded","Kharghar","Panvel","Akola","Latur","Malegaon"
  ],
  "Manipur": [
    "Imphal","Churachandpur","Thoubal","Kakching","Moirang","Yairipok",
    "Wangjing","Lilong","Nambol","Sekmai Bazar","Mayang Imphal","Kumbi",
    "Wabagai","Lamsang","Sugnu"
  ],
  "Meghalaya": [
    "Shillong","Tura","Nongpoh","Jowai","Baghmara","Williamnagar",
    "Resubelpara","Nongstoin","Mairang","Mawkyrwat","Sohra","Khliehriat"
  ],
  "Mizoram": [
    "Aizawl","Lunglei","Saiha","Champhai","Serchhip","Kolasib",
    "Lawngtlai","Mamit","Saitual","Hnahthial","North Vanlaiphai"
  ],
  "Nagaland": [
    "Dimapur","Kohima","Mokokchung","Tuensang","Zunheboto","Wokha",
    "Mon","Phek","Chumukedima","Kiphire","Peren","Longleng"
  ],
  "Odisha": [
    "Bhubaneswar","Cuttack","Rourkela","Brahmapur","Sambalpur","Puri",
    "Balasore","Baripada","Bhadrak","Angul","Balangir","Barbil","Bargarh",
    "Bhanjanagar","Bhawanipatna","Byasanagar","Chatrapur","Dhenkanal","Gunupur",
    "Hinjilicut","Jagatsinghapur","Jajpur Road","Jharsuguda","Joda","Kendrapara",
    "Kendujhar","Koraput","Malkangiri","Paradip","Paralakhemundi","Phulbani",
    "Rayagada","Talcher"
  ],
  "Punjab": [
    "Ludhiana","Amritsar","Jalandhar","Patiala","Bathinda","Mohali",
    "Hoshiarpur","Moga","Batala","Pathankot","Abohar","Malerkotla",
    "Khanna","Muktsar","Barnala","Firozpur","Phagwara","Rajpura","Mukerian"
  ],
  "Rajasthan": [
    "Jaipur","Jodhpur","Kota","Bikaner","Ajmer","Udaipur","Bhilwara",
    "Alwar","Sikar","Pali","Sri Ganganagar","Hanumangarh","Jhunjhunu",
    "Churu","Tonk","Bharatpur","Baran","Banswara","Dausa","Nagaur",
    "Jhalawar","Sawai Madhopur","Chittorgarh","Dholpur","Karauli"
  ],
  "Sikkim": [
    "Gangtok","Namchi","Geyzing","Mangan","Singtam","Rangpo",
    "Jorethang","Soreng","Pakyong","Rhenock","Yuksom"
  ],
  "Tamil Nadu": [
    "Chennai","Coimbatore","Madurai","Tiruchirappalli","Salem","Tirunelveli",
    "Tiruppur","Vellore","Erode","Thoothukudi","Dindigul","Thanjavur",
    "Nagercoil","Kanchipuram","Karur","Ambur","Cuddalore","Pudukkottai",
    "Sivakasi","Nagapattinam","Pollachi","Arakkonam","Namakkal","Rajapalayam"
  ],
  "Telangana": [
    "Hyderabad","Warangal","Karimnagar","Nizamabad","Khammam","Mancherial",
    "Mahbubnagar","Ramagundam","Nalgonda","Adilabad","Suryapet",
    "Miryalaguda","Siddipet","Jagtial","Bodhan","Kamareddy","Zaheerabad"
  ],
  "Tripura": [
    "Agartala","Udaipur","Dharmanagar","Kailasahar","Belonia","Khowai",
    "Ambassa","Panisagar","Kamalpur","Sonamura","Sabroom"
  ],
  "Uttar Pradesh": [
    "Lucknow","Kanpur","Ghaziabad","Agra","Varanasi","Meerut","Prayagraj",
    "Bareilly","Aligarh","Moradabad","Saharanpur","Gorakhpur","Noida",
    "Firozabad","Jhansi","Muzaffarnagar","Mathura","Ayodhya","Shahjahanpur",
    "Rampur","Etawah","Sitapur","Raebareli","Lakhimpur","Unnao","Bulandshahr",
    "Faizabad","Barabanki","Fatehpur","Hapur","Budaun"
  ],
  "Uttarakhand": [
    "Dehradun","Haridwar","Haldwani","Roorkee","Rudrapur","Kashipur",
    "Rishikesh","Nainital","Pithoragarh","Tehri","Almora","Kotdwara",
    "Champawat","Bageshwar","Pauri","Mussoorie"
  ],
  "West Bengal": [
    "Kolkata","Asansol","Siliguri","Durgapur","Howrah","Bardhaman",
    "Malda","Kharagpur","Haldia","Berhampore","Jalpaiguri","Chandannagar",
    "Bongaon","Cooch Behar","Serampore","Raiganj","Balurghat"
  ],
  "Delhi": [
    "New Delhi","Delhi Cantonment","Karol Bagh","Rohini","Dwarka",
    "Saket","Narela","Shahdara","Najafgarh","Patel Nagar","Laxmi Nagar",
    "Rajouri Garden","Janakpuri","Model Town","Vasant Kunj"
  ],
  "Jammu and Kashmir": [
    "Srinagar","Jammu","Baramulla","Udhampur","Anantnag","Kathua",
    "Sopore","Pulwama","Rajouri","Ganderbal","Poonch","Kupwara",
    "Bandipora","Handwara","Kulgam","Budgam"
  ],
  "Ladakh": [
    "Leh","Kargil","Diskit","Nubra","Padum","Nyoma"
  ],

};

const AddSupplier = () => {
  const [open2, setOpen2] = useState(true);
  const [selectedState, setSelectedState] = useState('');

  const [formValues, setFormValues] = useState({
    name: '',
    contactPerson: '',
    mobileNo: [''],
    email: [''],
    GSTNo: '',
    address: {
      street: '',
      city: '',
      state: '',
      pincode: '',
      country: '',
    },
  });

  const handleInputChange = (e) => {
    const { name, value, dataset } = e.target;

    if (name in formValues.address) {
      setFormValues((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [name]: value,
          ...(name === 'state' && { city: '' }),
        },
      }));
      if (name === 'state') setSelectedState(value);
    } else if (name === 'mobileNo') {
      const index = parseInt(dataset.index, 10);
      const updatedMobile = [...formValues.mobileNo];
      updatedMobile[index] = value;
      setFormValues((prev) => ({ ...prev, mobileNo: updatedMobile }));
    } else if (name === 'email') {
      const index = parseInt(dataset.index, 10);
      const updatedEmail = [...formValues.email];
      updatedEmail[index] = value;
      setFormValues((prev) => ({ ...prev, email: updatedEmail }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const addField = (key) => {
    setFormValues((prev) => ({ ...prev, [key]: [...prev[key], ''] }));
  };

  const removeField = (key, index) => {
    setFormValues((prev) => {
      const updated = [...prev[key]];
      updated.splice(index, 1);
      return { ...prev, [key]: updated };
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const { name, contactPerson, mobileNo, email, GSTNo, address } = formValues;

  if (!name.trim()) return Swal.fire('Validation Error', 'Name is required', 'error');
  if (!contactPerson.trim()) return Swal.fire('Validation Error', 'Contact Person is required', 'error');
  if (mobileNo.length === 0 || mobileNo.some((m) => !/^\d{10}$/.test(m.trim())))
    return Swal.fire('Validation Error', 'All mobile numbers must be 10 digits', 'error');

  // ✅ Trim and clean emails
  const cleanedEmails = email.map((e) => e.trim()).filter((e) => e !== '');
  if (
    cleanedEmails.length === 0 ||
    cleanedEmails.some((e) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e))
  ) {
    return Swal.fire('Validation Error', 'All emails must be valid and non-empty', 'error');
  }

  const requiredFields = ['street', 'city', 'state', 'pincode', 'country'];
  const missingField = requiredFields.find((field) => !address[field]?.trim());
  if (missingField) return Swal.fire('Validation Error', `Address ${missingField} is required`, 'error');

  try {
    const payload = {
      ...formValues,
      email: cleanedEmails, // ✅ use cleaned email list
    };

    await PoServices.createNewSupplier(payload);
    Swal.fire('Success', 'Supplier added successfully', 'success');

    setFormValues({
      name: '',
      contactPerson: '',
      mobileNo: [''],
      email: [''],
      GSTNo: '',
      address: { street: '', city: '', state: '', pincode: '', country: '' },
    });
    setSelectedState('');
  } catch (error) {
    Swal.fire('Error', error?.response?.data?.message || 'Something went wrong', 'error');
  }
};


  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">
          <div className="content-title">
            <div className="cpa"><i className="fas fa-user me-2"></i> Add Supplier</div>
            <div className="tools">
              <Link to={"#"} className={`SlideToolHeader ${open2 ? 'collapse' : 'expand'}`} onClick={() => setOpen2(!open2)}>
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>

          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Name & Contact Person */}
                    <div className="form-group mb-1 col-md-6">
                      <label>Name</label>
                      <input type="text" name="name" className="form-control" value={formValues.name} onChange={handleInputChange} />
                    </div>
                    <div className="form-group mb-1 col-md-6">
                      <label>Contact Person</label>
                      <input type="text" name="contactPerson" className="form-control" value={formValues.contactPerson} onChange={handleInputChange} />
                    </div>

                    {/* Mobile */}
                    <div className="form-group mb-1 col-md-6">
                      <label>Mobile No(s)</label>
                      {formValues.mobileNo.map((num, index) => (
                        <div className="d-flex mb-1" key={index}>
                          <input type="text" name="mobileNo" data-index={index} className="form-control" value={num} onChange={handleInputChange} />
                          <button type="button" className="btn btn-danger btn-sm ms-1" onClick={() => removeField('mobileNo', index)}>-</button>
                        </div>
                      ))}
                      <button type="button" className="btn btn-primary btn-sm mt-1" onClick={() => addField('mobileNo')}>+ Add</button>
                    </div>

                    {/* Email */}
                    <div className="form-group mb-1 col-md-6">
                      <label>Email(s)</label>
                      {formValues.email.map((mail, index) => (
                        <div className="d-flex mb-1" key={index}>
                          <input type="text" name="email" data-index={index} className="form-control" value={mail} onChange={handleInputChange} />
                          <button type="button" className="btn btn-danger btn-sm ms-1" onClick={() => removeField('email', index)}>-</button>
                        </div>
                      ))}
                      <button type="button" className="btn btn-primary btn-sm mt-1" onClick={() => addField('email')}>+ Add</button>
                    </div>

                    {/* GST No */}
                    <div className="form-group mb-1 col-md-6">
                      <label>GST No.</label>
                      <input type="text" name="GSTNo" className="form-control" value={formValues.GSTNo} onChange={handleInputChange} />
                    </div>

                    {/* Address */}
                    <div className="form-group mb-1 col-md-6">
                      <label>Street</label>
                      <input type="text" name="street" className="form-control" value={formValues.address.street} onChange={handleInputChange} />
                    </div>

                    <div className="form-group mb-1 col-md-4">
                      <label>State</label>
                      <select name="state" className="form-control" value={formValues.address.state} onChange={handleInputChange}>
                        <option value="">Select State</option>
                        {Object.keys(stateCityData).map((state) => (
                          <option key={state} value={state}>{state}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group mb-1 col-md-4">
                      <label>City</label>
                      <select name="city" className="form-control" value={formValues.address.city} onChange={handleInputChange} disabled={!selectedState}>
                        <option value="">Select City</option>
                        {(stateCityData[selectedState] || []).map((city) => (
                          <option key={city} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group mb-1 col-md-4">
                      <label>Pincode</label>
                      <input type="text" name="pincode" className="form-control" value={formValues.address.pincode} onChange={handleInputChange} />
                    </div>

                    <div className="form-group mb-1 col-md-4">
                      <label>Country</label>
                      <input type="text" name="country" className="form-control" value={formValues.address.country} onChange={handleInputChange} />
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary me-2 mt-3">Add Supplier</button>
                  <button type="reset" className="btn btn-danger mt-3" onClick={() => {
                    setFormValues({
                      name: '', contactPerson: '', mobileNo: [''], email: [''], GSTNo: '',
                      address: { street: '', city: '', state: '', pincode: '', country: '' }
                    });
                    setSelectedState('');
                  }}>Cancel</button>
                </form>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default AddSupplier;
